import { FC } from 'react'

import styles from './TrialExpiryButton.module.scss'
import { TrialExpiryButtonProps } from './TrialExpiryButton.types'

export const TrialExpiryButton: FC<TrialExpiryButtonProps> = ({
  onClick,
  label
}) => {
  return (
    <button className={styles.trialExpiryButton} onClick={onClick}>
      {label}
    </button>
  )
}
